import { DashboardService } from "services";

import DashboardCalendarSection from "../shared/DashboardCalendarSection";

interface CalendarSectionProps {
  className?: string;
  compact?: boolean;
}

const CalendarSection = ({ className, compact = false }: CalendarSectionProps) => (
  <DashboardCalendarSection
    className={className}
    compact={compact}
    loadCalendar={DashboardService.getAgentCalendar}
  />
);

export default CalendarSection;
